import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import httpClient from '../../../service/http.service';
import { SNACKBAR_OPEN } from '../component/snackbar/snackbar.component';
import {
  BACKDROP_TRUE,
  BACKDROP_FALSE,
} from '../component/loaderBackDrop/loaderBackDrop.component';
import {
  ACL_GROUP_LIST,
  ACL_PERMISSION_LIST,
  ACL_USER_LIST,
  AUTOVIEW_LIST,
  BANNER_LIST,
  BANNER_SLIDER_LIST,
  BADGE_LIST,
  CATEGORY_LIST,
  COLLECTION_LIST,
  COLLECTION_PHOTO_LIST,
  COLLECTION_TYPE_LIST,
  COMMENT_MEDIA,
  COMMENT_USER,
  CONTEST_LIST,
  CONTEST_TYPE_LIST,
  EDITORIAL_AUTHOR_LIST,
  FEATURE_BOX_LIST,
  FEATURE_LOCATION_LIST,
  MEDIA_MENTION,
  MESSAGE_NOTIFICATION,
  MRSS_CATEGORY_LIST,
  MRSS_LIST,
  MRSS_MEDIA_LIST,
  MRSS_EIPSODES_LIST,
  PARTNER_LIST,
  PARTNER_EXCLUSIVE_LIST,
  PHOTO_LIST,
  REPORT_AIRVUZ_MRSS,
  REPORT_CONTRIBUTOR,
  REPORT_HEAVILY_COMMENT_MEDIA,
  REPORT_JUDGE,
  REPORT_JUDGE_COLLECTION,
  REPORT_JUDGE_ONE,
  REPORT_MISSING_CONTRIBUTOR,
  REPORT_NEW_CONTRIBUTOR,
  REPORT_NEW_USER,
  REPORT_SOCIAL_MEDIA_SHARE,
  REPORT_VIDEO_FEATURE_LIST,
  REPORT_UPLOADS,
  SITE_INFO,
  TOP_CONTRIBUTOR,
  TV_LIST,
  TV_FEATURE,
  VIDEO_LIST,
  UPLOAD_LIST,
  MRSS_SERIES_LIST,
  MESSAGE_NOTIFICATION_LIST,
} from '../../../redux/action/type.action';

export const useAclGroupList = () => useReducer(ACL_GROUP_LIST);
export const useAclPermissionList = () => useReducer(ACL_PERMISSION_LIST);
export const useAclUserList = () => useReducer(ACL_USER_LIST);
export const useAutoViewList = () => useReducer(AUTOVIEW_LIST);

export const useBadgeList = () => useReducer(BADGE_LIST);
export const useBannerList = () => useReducer(BANNER_LIST);
export const useBannerSliderList = () => useReducer(BANNER_SLIDER_LIST);

export const useCategoryList = () => useReducer(CATEGORY_LIST);
export const useCollectionList = () => useReducer(COLLECTION_LIST);
export const useCollectionTypeList = () => useReducer(COLLECTION_TYPE_LIST);
export const useCollectionPhotoList = () => useReducer(COLLECTION_PHOTO_LIST);

export const useCommentMedia = () => useReducer(COMMENT_MEDIA);
export const useCommentUser = () => useReducer(COMMENT_USER);
export const useContestList = () => useReducer(CONTEST_LIST);
export const useContestTypeList = () => useReducer(CONTEST_TYPE_LIST);

export const useEditorialAuthorList = () => useReducer(EDITORIAL_AUTHOR_LIST);

export const useFeatureBoxList = () => useReducer(FEATURE_BOX_LIST);
export const useFeatureBoxLocationList = () => useReducer(FEATURE_LOCATION_LIST);

export const useMediaMention = () => useReducer(MEDIA_MENTION);
export const useMessageNotification = () => useReducer(MESSAGE_NOTIFICATION);
export const useMessageNotificationList = () => useReducer(MESSAGE_NOTIFICATION_LIST);
export const useMrssCategoryList = () => useReducer(MRSS_CATEGORY_LIST);
export const useMrssList = () => useReducer(MRSS_LIST);
export const useMrssMediaList = () => useReducer(MRSS_MEDIA_LIST);
export const useMrssEpisodesList = () => useReducer(MRSS_EIPSODES_LIST);
export const useMrssSeriesList = () => useReducer(MRSS_SERIES_LIST);

export const usePartnerList = () => useReducer(PARTNER_LIST);
export const usePartnerExclusiveList = () => useReducer(PARTNER_EXCLUSIVE_LIST);
export const usePhotoList = () => useReducer(PHOTO_LIST);

export const useReportAirvuzMRSS = () => useReducer(REPORT_AIRVUZ_MRSS);
export const useReportContributor = () => useReducer(REPORT_CONTRIBUTOR);
export const useReportHeavilyCommentMedia = () => useReducer(REPORT_HEAVILY_COMMENT_MEDIA);
export const useReportJudgeCollection = () => useReducer(REPORT_JUDGE_COLLECTION);
export const useReportJudge = () => useReducer(REPORT_JUDGE);
export const useReportJudgeOne = () => useReducer(REPORT_JUDGE_ONE);
export const useReportMissingContributor = () => useReducer(REPORT_MISSING_CONTRIBUTOR);
export const useReportNewContributor = () => useReducer(REPORT_NEW_CONTRIBUTOR);
export const useReportNewUser = () => useReducer(REPORT_NEW_USER);
export const useReportSocialMediaShare = () => useReducer(REPORT_SOCIAL_MEDIA_SHARE);
export const useReportUploads = () => useReducer(REPORT_UPLOADS);
export const useReportVideoFeatureList = () => useReducer(REPORT_VIDEO_FEATURE_LIST);

export const useSiteInfo = () => useReducer(SITE_INFO);

export const useTopContributor = () => useReducer(TOP_CONTRIBUTOR);
export const useTVList = () => useReducer(TV_LIST);
export const useTVFeature = () => useReducer(TV_FEATURE);
export const useVideoList = () => useReducer(VIDEO_LIST);
export const useUploadList = () => useReducer(UPLOAD_LIST);
interface IReducer {
  name: string;
  type: string;
  api: string;
  set: string;
  clear: string;
  reducerType?: string | string[];
}

const useReducer = (REDUCER: IReducer) => {
  const dispatch = useDispatch();
  const reducer = useSelector((state: any) => state[REDUCER.name]);
  const [checkLastTime, setLastCheckTime] = useState(reducer.check);

  const setControl = (key) => {
    dispatch({
      type: REDUCER.set,
      payload: {
        ...reducer,
        param: {
          ...reducer.param,
          ...key,
        },
      },
    });
  };

  const setData = (data) => {
    dispatch({
      type: REDUCER.set,
      payload: {
        ...reducer,
        data: data,
      },
    });
  };

  const setIdData = (data) => {
    dispatch({
      type: REDUCER.set,
      payload: {
        ...reducer,
        dataSource: {
          ...reducer.dataSource,
          [data._id]: data,
        },
      },
    });
  };

  useEffect(() => {
    if (!reducer.data) {
      if (REDUCER.reducerType?.includes('time')) {
        setLastCheckTime(new Date());
      }
      if (REDUCER.reducerType?.includes('param')) {
        dispatch({
          type: REDUCER.set,
          payload: {
            ...reducer,
          },
        });
      } else {
        getData();
      }
    }
  }, [reducer.data]);

  useEffect(() => {
    if (REDUCER.reducerType?.includes('time')) {
      if (checkLastTime) {
        let lastTime = new Date(checkLastTime);
        let timeNow = new Date();
        let difference = timeNow.getTime() - lastTime.getTime();
        let resultInMinutes = Math.round(difference / 60000);
        if (resultInMinutes >= 5) {
          // check if over 5min
          console.log(`...refreshing ${REDUCER.type}`);
          setLastCheckTime(timeNow);
          getData();
        }
      }
    }
  }, []);

  const getData = async (
    param?: {
      param1?: string;
      param1Value?: string;
      param2?: string;
      param2Value?: string;
      param3?: string;
      param3Value?: string;
      ids?: string[];
      id?: string;
      api?: string;
    },
    key?: any
  ) => {
    dispatch(BACKDROP_TRUE);
    let parameter: any;
    if (param && param.param1 && !REDUCER.reducerType?.includes('post')) {
      let param1 = param.param1 ? param.param1 : reducer.param.param1 ? reducer.param.param1 : null;
      let param2 = param?.param2
        ? param?.param2
        : reducer?.param?.param2
        ? reducer?.param?.param2
        : null;
      let param3 = param?.param3
        ? param?.param3
        : reducer?.param?.param3
        ? reducer?.param?.param3
        : null;
      param1 && (parameter = param1 + '=' + param?.param1Value);
      param2 && (parameter = parameter + '&' + param2 + '=' + param.param2Value);
      param3 && (parameter = parameter + '&' + param3 + '=' + param.param3Value);
    }
    try {
      let result: any;
      let http;
      if (!REDUCER.reducerType?.includes('post')) {
        http = httpClient.get;
        if (param && param.api) {
          result = await http(`${param.api}`);
        } else if (param && param.id) {
          result = await http(`${REDUCER.api}/${param.id}`);
        } else if (parameter) {
          result = await http(`${REDUCER.api}?${parameter}`);
        } else if (!parameter && !param) {
          result = await http(`${REDUCER.api}`);
        }
      } else {
        http = httpClient.post;
        if (param && param.id) {
          result = await http(`${REDUCER.api}`, { id: param.id });
        }
      }
      if (result.data) {
        let newPayload = {
          ...reducer,
        };
        newPayload.data = result.data.data;
        if (REDUCER.reducerType?.includes('param')) {
          newPayload.param = {
            ...reducer.param,
            ...param,
          };
        }
        if (REDUCER.reducerType?.includes('time')) {
          let time = checkLastTime ? checkLastTime : new Date();
          newPayload.check = time;
        }
        if (key) {
          dispatch(
            SNACKBAR_OPEN({
              message: `Found ${result.data.data.length}`,
            })
          );
        }
        dispatch({
          type: REDUCER.set,
          payload: newPayload,
        });
      }
      dispatch(BACKDROP_FALSE);
    } catch (error) {
      console.log(`...error getting ${REDUCER.type}`);
      // if(REDUCER.name === "PARTNER_EXCLUSIVE_LIST"){
      //   dispatch({
      //     type: REDUCER.set,
      //     payload: {data: placeholderData}
      //   })
      // }
      dispatch(
        SNACKBAR_OPEN({
          message: `Server Error: ${error} with ${REDUCER.type}`,
        })
      );
      dispatch(BACKDROP_FALSE);
    }
  };
  const refresh = () => {
    getData();
    dispatch({
      type: REDUCER.set,
      payload: {
        ...reducer,
        filterData: undefined,
        param: {
          ...reducer.param,
          viewDeleted: true,
        },
      },
    });
  };
  reducer.setControl = setControl; // attach to reducer
  reducer.getData = getData; // attach to reducer
  reducer.actions = REDUCER;
  reducer.setData = setData;
  reducer.refresh = refresh;
  reducer.setIdData = setIdData;
  return reducer;
};
